import React from 'react';
import styled from 'styled-components';

import MaterialSymbol from './MaterialSymbol';

const ArrowBackIconStyled = styled(MaterialSymbol)`
  display: block;
`;

const BackClickable = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
  cursor: pointer;
`;

type Props = {
  onClick?: () => void;
};

export default function BackIcon({ onClick }: Props) {
  return (
    <BackClickable onClick={onClick}>
      <ArrowBackIconStyled icon="arrow_back" />
    </BackClickable>
  );
}
